'use client';
import { SPRING_CONFIG_700_40 } from '#pplx/frontend/aether/config.js';
import { SpringValue } from '@react-spring/web';
import React, { createContext, useContext } from 'react';
export const getChromeSpringConfig = (visible) => ({
    ...(visible ? { tension: 300, friction: 34 } : SPRING_CONFIG_700_40),
    clamp: true,
});
const fallback = {
    visible: true,
    setVisible: () => undefined,
    spring: new SpringValue(1),
};
export const ChromeVisibilityContext = createContext(fallback);
export const useChromeVisibility = () => useContext(ChromeVisibilityContext);
//# sourceMappingURL=ChromeVisibilityProviderShared.js.map